module.exports = __webpack_public_path__ + "img/5th-grade-en.e613d702.png";